import SoundManager from "../managers/SoundManager"
import Button from "../objects/Button"

export default class Menu {

    dice
    mute
    fullscreen
    shuffleSize
    shuffleMargin
    soundManager
    items
    scale

    constructor(width, height, minSize, soundManager, shuffle, scale) {
        this.soundManager = soundManager
        this.scale = scale

        this.shuffleSize = minSize / 10
        this.shuffleMargin = this.shuffleSize / 2

        const padding = this.shuffleMargin + this.shuffleSize / 2

        this.dice = new Button(
            'dice',
            width - padding,
            padding,
            this.shuffleSize,
            shuffle
        )

        this.mute = new Button(
            'volume_on',
            padding,
            height - padding,
            this.shuffleSize / 2,
            () => {
                this.soundManager.toggleMute()
                this.mute.sprite.setTexture(this.soundManager.isMute ? 'volume_off' : 'volume_on')
            }
        )

        this.fullscreen = new Button(
            this.scale.isFullscreen ? 'fullscreen_exit' : 'fullscreen',
            padding,
            padding,
            this.shuffleSize / 2,
            () => {
                if (this.scale.isFullscreen) {
                    this.scale.stopFullscreen()
                    this.fullscreen.sprite.setTexture('fullscreen')
                } else {
                    this.scale.startFullscreen()
                    this.fullscreen.sprite.setTexture('fullscreen_exit')
                }
            }
        )

        this.items = [this.dice, this.mute, this.fullscreen]
    }

    destroy() {
        for (let item of this.items) {
            item.sprite.destroy()
        }
    }
}
